module.exports = __webpack_public_path__ + "img/img-exercise-muscle-04.3916328a.png";